import { KEGatewayClient } from '../KEGatewayClient';
import type { TCategoriesResponse, TPromoCategoriesResponse } from './models';
import type { ICategoriesService } from './ICategoriesService';

export class CategoriesService extends KEGatewayClient implements ICategoriesService {  
  public async getRootCategories(): Promise<TCategoriesResponse> {
    return this.get<TCategoriesResponse>('category/v2/root-categories', {
      cache: 'force-cache',
    });
  }

  public async getPromoCategories(): Promise<TPromoCategoriesResponse> {
    return this.get<TPromoCategoriesResponse>('main/promo-categories', {
      cache: 'force-cache',
    });
  }
}